import React, { useContext, useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import { getUsuarioVacio } from '../../interfaces/UsuariosRoles';
import NuevoUsuario from './NuevoUsuario';
import { Guardaruser } from '../../interfaces/UsuariosRoles';

import '../Icono/cardIcon.css';
import CatalogService from '../../services/CatalogService';
import UsuarioService from '../../services/UsuarioService';
import { Unidad } from '../../interfaces/Unidad';
import { CasUserContext, useCasUserContext } from '../../services/casUserContext';
import { PersonaInvDTO, VoidPersonaInvDTO } from '../../interfaces/Usuarios/PersonaInvDTO';
import { UserForm } from './UserForm';


const catalogService = new CatalogService();
const usuarioService = new UsuarioService();

interface opcion {
  value: string,
  label: string,
}
interface MiModalProps {
  isOpen: boolean;
  toggle: () => void;
  data: PersonaInvDTO;
}

export const ModalEditarUsuario: React.FC<MiModalProps> = ({ isOpen, toggle, data }) => {

  //const casUserContext = useContext(CasUserContext);
  const casUserContext = useCasUserContext();
  const token = casUserContext.token;
  const [unidades, setUnidades] = useState<Array<Unidad>>([])
  const unidadesOpcion: Array<opcion> = Array<opcion>()
  const [userFull, setUserFull] = useState<PersonaInvDTO>(() => VoidPersonaInvDTO())

  const fetchData = async () => {
    try {
      await catalogService.obtenerCatalogoUnidades()
        .then((data) => setUnidades(data.objDatos))
        .catch((error) => console.error(error))
    } catch (error) {
      console.error('Error:', error);
    }
  };

  unidades.map((row) => {
    let opc: opcion = {
      value: row.idunidad.toString(),
      label: row.nombreunidad
    }
    unidadesOpcion.push(opc)
  })

  useEffect(() => {
    fetchData();

  }, [data])

  const handleResponse = async (responseData: PersonaInvDTO) => {
    // Manejar la respuesta aquí
    setTimeout(() => {
      window.location.reload();
    }, 3000); // 3000 milisegundos = 3 segundos
  }

  return (
    <>
      <Modal className='modal-lg' isOpen={isOpen} toggle={toggle} >
        <ModalHeader>Editar usuario</ModalHeader>
        <ModalBody style={{ padding: '20px' }}>
          <UserForm usuario={data} token={token} onResponse={handleResponse}/>
        </ModalBody>
      </Modal>
    </>
  )

}